module.exports = __webpack_public_path__ + "media/application/images/logo-c5d6a170d40d85ed35db8032d3326337.svg";